module.exports = __webpack_public_path__ + "static/media/roi-reduction-in-er.b0d0564b.png";